<template>
  <div id="emergency-plan2">
    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
    <div class="wrapper">
      <div class="section section1">
        <span class="title">应急保障</span>
        <span class="tip"> — 方案咨询</span>
        <span class="right" @click="goBackClick">返回上一步 ></span>
      </div>
      <div class="section section2">
          <!--  多选  -->
        <div class="content">
          <div class="que-box m-que-box"  v-for="(value,index) in categoryData" :key="index">
            <div class="que-title">{{value.title}}<span v-show="index===0||index===3">(可多选)</span><span v-show="index===1||index===2">(非必填，可多选)</span></div>
            <div class="box-input" v-for="(item,ind) in value.list" :key="ind">
              <div class="que-value" @click="itemClick(index,item,ind)">
                <div class="image" :class="{'defaultImage': !item.isSel,'selImage': item.isSel}" ></div>
                <div class="value">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="plan-box">
          <div class="plan plan1" v-show="showPlan1">
            <div class="header">
              <div class="title">安保人员</div>
              <div class="tip" @click="priceTipClick"><img src="../assets/icon-money.png">服务价格</div>
            </div>
            <div class="item-box que-box">
              <div class="title">安保类型<span>(必填)</span></div>
              <div class="box-input" v-for="(item,index) in securityData.list" :key="index">
                <div class="que-value" @click="sItemClick(securityData.list,item,index)">
                  <div class="image" :class="{'defaultImage': planInfo.security_type!==index+1,'selImage': planInfo.security_type===index+1}" ></div>
                  <div class="value">{{item.title}}</div>
                  <div class="vtip" v-show="planInfo.security_type===index+1">工作不满{{pHour}}小时，以{{pHour}}小时计算</div>
                </div>
              </div>
            </div>
            <div class="item-box cycle-box">
              <div class="title">需求周期<span>(必填)</span></div>
              <div class="tip">江浙沪需提前<span>3</span>天预订，省外提前<span>7</span>天预订 </div>
              <div class="cycleBox">
                <input class="start" v-model="planInfo.security_demand_start" placeholder="请选择" readonly @click="showTimeClick(1)" />
                <div class="tip11">至</div>
                <input class="end" v-model="planInfo.security_demand_end" placeholder="请选择" readonly @click="showTimeClick(2)" />
              </div>
              <div class="tip3">共&nbsp;<span class="tip31">{{pTime}}</span>&nbsp;天&nbsp;&nbsp;<span v-show="planInfo.across_day" class="tip32">（工作节点{{endTimeStr}}{{planInfo.work_time_end}}:00）</span></div>
            </div>
            <div class="item-box time-box">
              <div class="title">工作时间<span>(必填)</span></div>
              <div class="timeBox">
                <input class="sHour" v-model="planInfo.work_time_start" readonly @click="showTimeClick2" />
                <div class="tip11">:</div>
                <input class="sSecond" v-model="sSecond" readonly />
                <div class="tip22">至</div>
                <input class="eHour" v-model="planInfo.work_time_end" readonly />
                <div class="tip33">:</div>
                <input class="eSecond" v-model="eSecond" readonly />
              </div>
              <div class="tip3">共&nbsp;<span class="tip31">{{pHour}}</span>&nbsp;小时&nbsp;&nbsp;<span v-show="planInfo.across_day" class="tip32">（周期跨1天）</span></div>
            </div>
            <div class="item-box person-box">
              <div class="title">安保人数<span>(必填)</span></div>
              <div class="tip">最少满足<span>5</span>位安保人员才可下单</div>
              <div class="numberBox">
                <div class="minus" :style="{backgroundColor:(planInfo.security_guard_num>5)?'#ffffff':'#eeeeee'}" @click="personMinusClick"><h4>-</h4></div>
                <input type="number" v-model="planInfo.security_guard_num" onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"  />
                <div class="plus" @click="personPlusClick"><h4>+</h4></div>
              </div>
            </div>
          </div>
          <div class="plan plan2" v-show="showPlan2">
            <div class="header">
              <div class="title">消防车租赁</div>
              <div class="tip" @click="priceTipClick"><img src="../assets/icon-money.png">服务价格</div>
            </div>
            <div class="item-box car-box">
              <div class="title">消防车租赁<span>(必填)</span></div>
              <div class="tip">消防车配备数量参考 <br/>（活动人数：<span>200人</span>/辆、活动面积：<span>500平米</span>/台）</div>
              <div class="numberBox">
                <div class="minus" :style="{backgroundColor:(planInfo.car_rental_num>1)?'#ffffff':'#eeeeee'}" @click="carMinusClick"><h4>-</h4></div>
                <input type="number" v-model="planInfo.car_rental_num" onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}" />
                <div class="plus" @click="carPlusClick"><h4>+</h4></div>
              </div>
              <div class="tip2">根据安保人员需求，预估您需要租赁3辆消防车</div>
            </div>
            <div class="item-box cycle-box">
              <div class="title">需求周期<span>(必填)</span></div>
              <div class="tip">江浙沪需提前<span>3</span>天预订，省外提前<span>7</span>天预订 </div>
              <div class="cycleBox">
                <input class="start" v-model="planInfo.car_rental_start" placeholder="请选择" readonly @click="showTimeClick(3)" />
                <div class="tip11">至</div>
                <input class="end" v-model="planInfo.car_rental_end" placeholder="请选择" readonly @click="showTimeClick(4)" />
              </div>
              <div class="tip3">共&nbsp;<span>{{cTime}}</span>&nbsp;天</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottomButton title="提交" :state="1" @click="bottomClick"></bottomButton>
    <timePicker :show="showTimePicker" :type="isThreeAddress" @timePicker="timePicker"></timePicker>
    <SPicker :show="showTimePicker2" type="2" @selectedSPicker="selectedSPicker"></SPicker>
    <InfoView :show="showInfoView" type="1" @infoViewClick="infoViewClick"></InfoView>
  </div>
</template>

<script>
import mainHeader from '../view/header'
import bottomButton from '../components/bottom-button'
import timePicker from '../components/time-picker'
import SPicker from '../components/single-picker'
import InfoView from '../components/info-view'
import { Toast } from 'mint-ui'
// import wxShare from '../wx/weixin.js'
export default {
  data () {
    return {
      planId: 0,
      showPlan1: false,
      showPlan2: false,
      showTimePicker: false,
      showTimePicker2: false,
      showInfoView: false,
      isThreeAddress: 0,
      categoryData: [
        {'title': '场所选择',
          'list': [
            {'title': '大型商城', isSel: 0},
            {'title': '活动现场', isSel: 0},
            {'title': '园区', isSel: 0},
            {'title': '学校', isSel: 0},
            {'title': '医院', isSel: 0},
            {'title': '其他场所', isSel: 0}]
        },
        {'title': '需求选择',
          'list': [
            {'title': '灾害救援', isSel: 0},
            {'title': '管理提升', isSel: 0},
            {'title': '应急保障', isSel: 0}
          ]},
        {'title': '客户属性',
          'list': [
            {'title': '社会企业', isSel: 0},
            {'title': '国有企业', isSel: 0},
            {'title': '政府', isSel: 0}
          ]},
        {'title': '租赁需求',
          'list': [
            {'title': '安保人员', isSel: 0},
            {'title': '消防车租赁', isSel: 0}
          ]}
      ],
      securityData: {'title': '安保类型',
        'list': [
          {'title': '单班保障(工作8小时)'},
          {'title': '双班保障(工作16小时)'},
          {'title': '三班保障(工作24小时)'}]
      },
      timeType: 0, // 点击选择需求周期时间类型 1-4
      pTime: 0, // 安保总时间
      sSecond: '00',
      eSecond: '00',
      pHour: 8, // 安保 每天 多少小时
      endTimeStr: '', // 节点时间
      cTime: 0, // 消防车租赁总时间 天
      planInfo: {
        id: 0,
        user_name: '',
        phone: '',
        address_detail: '',
        region_id: 0,
        ent_region: '',
        province_city_area: '',
        province: '',
        city: '',
        area: '',
        place: '',
        demand: '',
        customer_property: '',
        lease_types: '', // 安保人数
        security_type: 1, // 安保类型 1 2 3
        security_guard_num: 5,
        security_demand_start: '', // 安保开始时间
        security_demand_end: '', // 安保结束时间
        work_time_start: '00', // 安保开始 小时
        work_time_end: '08', // 安保开始结束 小时
        across_day: 0, // 是否 跨一天
        security_actual_end_date: '', // 真正结束日期
        logistics_match: '', // 省份
        car_rental_num: 1, // 消防车租赁数
        car_rental_start: '', // 消防车租赁开始时间
        car_rental_end: '' // 消防车租赁结束时间
      }
    }
  },
  methods: {
    logoutClick: function () { // 退出登录
      this.$router.push({path: 'home'})
    },
    goBackClick: function () {
      this.$router.go(-1)
    },
    priceTipClick: function () {
      this.showInfoView = true
    },
    infoViewClick: function () {
      this.showInfoView = false
    },
    itemClick: function (index, value, index2) { // 多选
      if (value.isSel === 0) {
        value.isSel = 1
      } else {
        value.isSel = 0
        // 隐藏
        if (index === 3) {
          if (index2 === 0) { // 选中 安保人员
            this.showPlan1 = false
          }
          if (index2 === 1) { // 选中 消防车租赁
            this.showPlan2 = false
          }
        }
      }
      // 展示
      if (index === 3) {
        if (value.isSel === 1) {
          if (index2 === 0) { // 选中 安保人员
            this.showPlan1 = true
          }
          if (index2 === 1) { // 选中 消防车租赁
            this.showPlan2 = true
          }
        }
      }
    },
    sItemClick: function (values, value, index) {
      this.planInfo.security_type = index + 1

      this.everyTimeState()
      this.crossState()
    },
    everyTimeState: function () {
      if (this.planInfo.security_type === 1) {
        this.pHour = 8
      }
      if (this.planInfo.security_type === 2) {
        this.pHour = 16
      }
      if (this.planInfo.security_type === 3) {
        this.pHour = 24
      }
    },
    crossState: function () {
      // 是否 跨天
      if (parseInt(this.planInfo.work_time_start) + this.pHour > 24) {
        this.planInfo.across_day = 1
      } else {
        this.planInfo.across_day = 0
      }
      // 一天 工作结束 小时
      if (this.pHour + parseInt(this.planInfo.work_time_start) < 24) {
        this.planInfo.work_time_end = (this.pHour + parseInt(this.planInfo.work_time_start)).toString()
      } else {
        this.planInfo.work_time_end = (this.pHour + parseInt(this.planInfo.work_time_start) - 24).toString()
      }
      if (this.planInfo.work_time_end.length <= 1) {
        this.planInfo.work_time_end = '0' + this.planInfo.work_time_end
      }
      // 跨天结束日期
      if (this.planInfo.across_day === 1 && !this.utils.isNull(this.planInfo.security_demand_start) && !this.utils.isNull(this.planInfo.security_demand_end)) {
        var date = new Date(this.planInfo.security_demand_end.replace(/-/g, '/'))
        console.log(date)
        let endDate = new Date(date.getTime() + 1 * 86400000)
        this.endTimeStr = (parseInt(endDate.getMonth()) + 1).toString() + '月' + (parseInt(endDate.getDate())).toString() + '日'
        this.planInfo.security_actual_end_date = endDate.getFullYear() + '-' + (parseInt(endDate.getMonth()) + 1).toString() + '-' + (parseInt(endDate.getDate())).toString()

        console.log(this.endTimeStr + this.planInfo.security_actual_end_date)
      } else {
        this.planInfo.security_actual_end_date = this.planInfo.security_demand_end
      }
    },
    personMinusClick: function () { // 安保人员 --
      if (this.planInfo.security_guard_num <= 5) return
      this.planInfo.security_guard_num -= 1
    },
    personPlusClick: function () { // 安保人员 ++
      this.planInfo.security_guard_num += 1
    },
    carMinusClick: function () { // 消防车 --
      console.log('消防车-===============')
      if (this.planInfo.car_rental_num <= 1) return
      this.planInfo.car_rental_num -= 1
    },
    carPlusClick: function () { // 消防车 ++
      console.log('消防车+===============')
      this.planInfo.car_rental_num += 1
    },
    showTimeClick: function (index) { // 选择周期
      this.timeType = index
      this.showTimePicker = true
    },
    timePicker: function (value) {
      this.showTimePicker = false
      if (value.length <= 0) {
        return
      }
      console.log(value)
      if (this.timeType === 1) {
        this.planInfo.security_demand_start = value
      }
      if (this.timeType === 2) {
        this.planInfo.security_demand_end = value
      }
      if (this.timeType === 3) {
        this.planInfo.car_rental_start = value
      }
      if (this.timeType === 4) {
        this.planInfo.car_rental_end = value
      }
      this.allDayState()
      this.crossState()
    },
    allDayState: function () { // 总共几天
      // 安保
      if (!this.utils.isNull(this.planInfo.security_demand_start) && !this.utils.isNull(this.planInfo.security_demand_end)) {
        var date1 = new Date(this.planInfo.security_demand_start.replace(/-/g, '/'))
        var date2 = new Date(this.planInfo.security_demand_end.replace(/-/g, '/'))
        if (date2 < date1) {
          Toast('请正确选择需求周期！')
          if (this.timeType === 1) {
            this.planInfo.security_demand_start = ''
          }
          if (this.timeType === 2) {
            this.planInfo.security_demand_end = ''
          }
          return
        }
        this.pTime = parseInt((date2.getTime() - date1.getTime()) / (24 * 60 * 60 * 1000)) + 1
      }
      // 消防车
      if (!this.utils.isNull(this.planInfo.car_rental_start) && !this.utils.isNull(this.planInfo.car_rental_end)) {
        var date3 = new Date(this.planInfo.car_rental_start.replace(/-/g, '/'))
        var date4 = new Date(this.planInfo.car_rental_end.replace(/-/g, '/'))
        if (date4 < date3) {
          Toast('请正确选择需求周期！')
          if (this.timeType === 3) {
            this.planInfo.car_rental_start = ''
          }
          if (this.timeType === 4) {
            this.planInfo.car_rental_end = ''
          }
          return
        }
        this.cTime = parseInt((date4.getTime() - date3.getTime()) / (24 * 60 * 60 * 1000)) + 1
      }
    },
    showTimeClick2: function () { // 选择 时分
      this.showTimePicker2 = true
    },
    selectedSPicker: function (value) {
      this.showTimePicker2 = false
      if (value.length > 0) {
        this.planInfo.work_time_start = value
        this.crossState()
      }
    },
    checkParam: function () {
      // if ()
      this.planInfo.place = ''
      this.planInfo.demand = ''
      this.planInfo.customer_property = ''
      this.planInfo.lease_types = ''
      for (let i = 0; i < this.categoryData.length; i++) {
        for (let j = 0; j < this.categoryData[i].list.length; j++) {
          let item = this.categoryData[i].list[j]
          if (item.isSel === 1) {
            if (i === 0) {
              this.planInfo.place += (item.title + ',')
            }
            if (i === 1) {
              this.planInfo.demand += (item.title + ',')
            }
            if (i === 2) {
              this.planInfo.customer_property += (item.title + ',')
            }
            if (i === 3) {
              this.planInfo.lease_types += (item.title + ',')
            }
          }
        }
      }
      if (!this.utils.isNull(this.planInfo.place)) {
        this.planInfo.place = this.planInfo.place.substr(0, this.planInfo.place.length - 1)
      } else {
        Toast('请选择场所')
        return false
      }
      if (!this.utils.isNull(this.planInfo.demand)) {
        this.planInfo.demand = this.planInfo.demand.substr(0, this.planInfo.demand.length - 1)
      }
      if (!this.utils.isNull(this.planInfo.customer_property)) {
        this.planInfo.customer_property = this.planInfo.customer_property.substr(0, this.planInfo.customer_property.length - 1)
      }
      if (!this.utils.isNull(this.planInfo.lease_types)) {
        this.planInfo.lease_types = this.planInfo.lease_types.substr(0, this.planInfo.lease_types.length - 1)
      } else {
        Toast('请选择租赁需求')
        return false
      }
      console.log(this.planInfo.lease_types)
      // 选择了 安保人员
      if (this.planInfo.lease_types.indexOf('安保人员') >= 0) {
        if (this.utils.isNull(this.planInfo.security_demand_start) || this.utils.isNull(this.planInfo.security_demand_end)) {
          Toast('请选择安保人员需求周期')
          return false
        }
        if (this.planInfo.security_guard_num < 5) {
          Toast('安保人员最少5人，才可下单')
          return false
        }
      }
      // 选择了 消防车租赁
      if (this.planInfo.lease_types.indexOf('消防车租赁') >= 0) {
        if (this.planInfo.car_rental_num < 1) {
          Toast('消防车最少1辆，才可下单')
          return false
        }
        if (this.utils.isNull(this.planInfo.car_rental_start) || this.utils.isNull(this.planInfo.car_rental_end)) {
          Toast('请选择消防车租赁周期')
          return false
        }
      }
      return true
    },
    bottomClick: function (type) { // 下一步
      console.log('=======================下一步')

      if (this.checkParam() === false) return
      var url = this.accountUrl + '/solutionsConsulting/newSubmit'
      var param = {
        user_name: this.planInfo.user_name,
        phone: this.planInfo.phone,
        address_detail: this.planInfo.address_detail,
        region_id: this.planInfo.region_id,
        ent_region: this.planInfo.province + this.planInfo.city + this.planInfo.area,
        province_city_area: this.planInfo.province + this.planInfo.city + this.planInfo.area,
        province: this.planInfo.province,
        city: this.planInfo.city,
        area: this.planInfo.area,
        place: this.planInfo.place,
        demand: this.planInfo.demand,
        customer_property: this.planInfo.customer_property,
        lease_types: this.planInfo.lease_types,
        security_type: this.planInfo.security_type,
        security_guard_num: this.planInfo.security_guard_num,
        security_demand_start: this.planInfo.security_demand_start,
        security_demand_end: this.planInfo.security_demand_end,
        work_time_start: this.planInfo.work_time_start,
        work_time_end: this.planInfo.work_time_end,
        across_day: this.planInfo.across_day,
        security_actual_end_date: this.planInfo.security_actual_end_date,
        logistics_match: this.planInfo.province,
        car_rental_num: this.planInfo.car_rental_num,
        car_rental_start: this.planInfo.car_rental_start,
        car_rental_end: this.planInfo.car_rental_end
      }

      if (this.planId > 0) {
        param.id = this.planId
        url = this.accountUrl + '/solutionsConsulting/updateSolutions'
      }
      console.log(param)
      var _this = this
      this.utils.POST(url, param, function (response) {
        if (response.code === 0) {
          if (_this.planId <= 0) {
            _this.planId = response.data
            param.id = _this.planId
          }
          console.log(param)
          localStorage.setItem('planInfo', _this.QS.stringify(param))
          _this.$router.push({path: 'emergency-detail', query: {planId: _this.planId}})
        }
      })
    },
    loadData: function () {
      let info = this.QS.parse(localStorage.getItem('planInfo'))
      console.log(info)
      console.log(info.address_detail)
      // 如果无 个人新消息 跳转 第一编辑界面
      if (info.phone === undefined) {
        this.$router.push({path: 'emergency-plan1'})
        return
      }

      if (info.province.indexOf('上海') >= 0 || info.province.indexOf('浙江') >= 0 || info.province.indexOf('江苏') >= 0) {
        this.isThreeAddress = 1
      } else {
        this.isThreeAddress = 2
      }
      // info.id = 780
      var _this = this
      if (info.id !== undefined) { // 以保存数据
        this.planId = info.id
        this.utils.GET(this.accountUrl + '/solutionsConsulting/consultingOrderMoneyInfo?id=' + this.planId, function (response) {
          if (parseInt(response.code) === 0) {
            _this.setDefaultInfo()
            _this.setView(response.data)
          }
        })
      } else {
        this.setDefaultInfo()
      }
    },
    setDefaultInfo: function () {
      console.log('设置默认信息===================1')

      let info = this.QS.parse(localStorage.getItem('planInfo'))
      this.planInfo.user_name = info.user_name
      this.planInfo.phone = info.phone
      this.planInfo.address_detail = info.address_detail
      this.planInfo.region_id = info.region_id
      this.planInfo.ent_region = info.province + info.city + info.area
      this.planInfo.province_city_area = info.province + info.city + info.area
      this.planInfo.province = info.province
      this.planInfo.city = info.city
      this.planInfo.area = info.area
      this.planInfo.logistics_match = info.province
      console.log('设置默认信息===================2')
    },
    setView: function (planInfo) {
      this.planInfo.id = this.planId
      for (let i = 0; i < this.categoryData.length; i++) {
        for (let j = 0; j < this.categoryData[i].list.length; j++) {
          let item = this.categoryData[i].list[j]
          if (i === 0) {
            if (planInfo.place.indexOf(item.title) >= 0) {
              item.isSel = 1
            }
          }
          if (i === 1) {
            if (planInfo.demand.indexOf(item.title) >= 0) {
              item.isSel = 1
            }
          }
          if (i === 2) {
            if (planInfo.customer_property.indexOf(item.title) >= 0) {
              item.isSel = 1
            }
          }
          if (i === 3) {
            if (planInfo.lease_types.indexOf(item.title) >= 0) {
              item.isSel = 1
            }
          }
        }
      }
      console.log(this.categoryData)
      if (planInfo.lease_types.indexOf('安保人员') >= 0 &&
        planInfo.lease_types.indexOf('消防车租赁') >= 0) {
        this.showPlan1 = true
        this.showPlan2 = true

        this.planInfo.security_type = planInfo.security_type // 安保类型 1 2 3
        this.planInfo.security_guard_num = planInfo.security_guard_num
        this.planInfo.security_demand_start = planInfo.security_demand_start // 安保开始时间
        this.planInfo.security_demand_end = planInfo.security_demand_end // 安保结束时间
        this.planInfo.work_time_start = planInfo.work_time_start // 安保开始 小时
        this.planInfo.work_time_end = planInfo.work_time_end // 安保开始结束 小时
        this.planInfo.across_day = planInfo.across_day // 是否 跨一天
        this.planInfo.security_actual_end_date = planInfo.security_actual_end_date
        this.planInfo.logistics_match = planInfo.logistics_match // 省份

        this.planInfo.car_rental_num = planInfo.car_rental_num // 消防车租赁数
        this.planInfo.car_rental_start = planInfo.car_rental_start // 消防车租赁开始时间
        this.planInfo.car_rental_end = planInfo.car_rental_end // 消防车租赁结束时间
      }
      if (planInfo.lease_types.indexOf('安保人员') >= 0 &&
        planInfo.lease_types.indexOf('消防车租赁') === -1) {
        this.showPlan1 = true

        this.planInfo.security_type = planInfo.security_type // 安保类型 1 2 3
        this.planInfo.security_guard_num = planInfo.security_guard_num
        this.planInfo.security_demand_start = planInfo.security_demand_start // 安保开始时间
        this.planInfo.security_demand_end = planInfo.security_demand_end // 安保结束时间
        this.planInfo.work_time_start = planInfo.work_time_start // 安保开始 小时
        this.planInfo.work_time_end = planInfo.work_time_end // 安保开始结束 小时
        this.planInfo.across_day = planInfo.across_day // 是否 跨一天
        this.planInfo.security_actual_end_date = planInfo.security_actual_end_date
        this.planInfo.logistics_match = planInfo.logistics_match // 省份

        this.planInfo.car_rental_num = 1 // 消防车租赁数
        this.planInfo.car_rental_start = '' // 消防车租赁开始时间
        this.planInfo.car_rental_end = '' // 消防车租赁结束时间
      }
      // 选择了 消防车租赁
      if (planInfo.lease_types.indexOf('消防车租赁') >= 0 &&
        planInfo.lease_types.indexOf('安保人员') === -1) {
        this.showPlan2 = true

        this.planInfo.security_type = 1 // 安保类型 1 2 3
        this.planInfo.security_guard_num = 5
        this.planInfo.security_demand_start = '' // 安保开始时间
        this.planInfo.security_demand_end = '' // 安保结束时间
        this.planInfo.work_time_start = '00' // 安保开始 小时
        this.planInfo.work_time_end = '08' // 安保开始结束 小时
        this.planInfo.across_day = 0 // 是否 跨一天
        this.planInfo.security_actual_end_date = ''
        this.planInfo.logistics_match = '' // 省份

        this.planInfo.car_rental_num = planInfo.car_rental_num // 消防车租赁数
        this.planInfo.car_rental_start = planInfo.car_rental_start // 消防车租赁开始时间
        this.planInfo.car_rental_end = planInfo.car_rental_end // 消防车租赁结束时间
      }

      this.everyTimeState()

      var _this = this
      setTimeout(function () {
        _this.crossState()
      }, 200)
      // return
      setTimeout(function () {
        _this.allDayState()
      }, 400)
      console.log('布局界面数据==========================444444')
      localStorage.setItem('planInfo', this.QS.stringify(this.planInfo))
      console.log(this.planInfo)
    }
  },
  watch: {
    $router () {
    }
  },
  computed: {
  },
  components: {
    mainHeader,
    bottomButton,
    timePicker,
    SPicker,
    InfoView
  },
  mounted () {
    document.body.scrollTop = document.documentElement.scrollTop = 0
    var _this = this
    this.utils.isUserLogin(function (login) {
      console.log('==========' + login)
      if (login === 0) {
        Toast('您还未登录，请登录后再评测！')
        _this.$router.push({path: 'login', query: {back: 1}})
      } else {
        _this.loadData()
      }
    })

    // 微信 分享
    // let imgUrl = 'http://cdn.zxzx119.com/39073939414056960'
    // wxShare.wxRegister('消防安全风险评测', '中消在线风险评测  一站式解决企业风险隐患', imgUrl)
  }
}
</script>

<style scoped>
  .mainHeader{
    position: fixed;
    top: 0px;
    height: 55px;
    width: 100%;
    z-index: 500;
  }
  .wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #F1F1F1;
    margin-top: 55px;
  }
  .section{
    position: relative;
    width: 100%;
    background-color: #FFFFFF;
  }
  .section1{
    height: 60px;
    box-sizing: border-box;
    border-bottom: #F1F1F1 solid 10px;
  }
  .section1 .title{
    height: 50px;
    line-height: 50px;
    color: #000;
    font-size: 16px;
    font-weight: bold;
    margin-left: 15px;
  }
  .section1 .tip{
    height: 50px;
    line-height: 50px;
    color: #000;
    font-size: 13px;
    font-weight: bold;
    margin-left: 5px;
  }
  .section1 .right{
    position: absolute;
    right: 15px;
    height: 50px;
    line-height: 50px;
    color: #999999;
    font-size: 13px;
    font-weight: bold;
  }
  .section2{
    position: relative;
    min-height: 300px;
    border-bottom: solid 65px #F1F1F1;
    box-sizing: border-box;
  }
  .section2 .content{
    position: relative;
    width: 100%;
    background-color: #FFFFFF;
  }
  .section2 .content .que-box{
    position: relative;
    width: 100%;
    border-bottom: solid 10px #F1F1F1;
    box-sizing: border-box;
  }
  .section2 .content .m-que-box:nth-of-type(4){
    border-bottom: solid 0px #FFFFFF;
    box-sizing: content-box;
  }
  .section2 .content .que-box .que-title{
    position: relative;
    top: 15px;
    margin-left: 15px;
    margin-right: 15px;
    line-height: 25px;
    color: #000000;
    font-size: 16px;
    font-weight: bold;
  }
  .que-title span{
    font-size: 12px;
    color: #BEBEBE;
    font-weight: normal;
    margin-left: 4px;
  }
  /* 单选 多选 */
  .section2 .content .que-box .box-input{
    position: relative;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 15px;
    line-height: 25px;
    /*background: yellow;*/
  }
  .section2 .content .que-box .box-input:nth-child(2){
    margin-top: 30px;
    /*background-color: #FFEECC;*/
  }
  .section2 .content .que-box .box-input:last-of-type{
    margin-bottom: 5px;
  }
  .section2 .content .que-box .box-input .que-value{
    position: relative;
    color: #000000;
    font-size: 14px;
  }
  .section2 .content .que-box .box-input .image{
    position: relative;
    top: 0px;
    margin-left: 0px;
    height: 20px;
    width: 20px;
  }
  .section2 .content .que-box .box-input .value{
    position: relative;
    top: -20px;
    margin-left: 30px;
    margin-right: 15px;
    line-height: 20px;
    color: #000000;
  }
  .defaultImage{
    background-image: url("../assets/radio_n.png");
    background-size: cover;
    background-position: center center;
  }
  .selImage{
    background-image: url("../assets/radio_s.png");
    background-size: cover;
    background-position: center center;
  }
  .plan-box{
    position: relative;
    width: 100%;
    background-color: #FFFFFF;
    /*min-height: 10px;*/
    /*height: 830px;*/
    /*height: 100px;*/
    border-bottom: solid 10px #F1F1F1;
    box-sizing: border-box;
  }
  .plan{
    position: relative;
    margin: 0px 15px;
    border: solid 1px #dedede;
    box-sizing: border-box;
  }
  .plan1{
    height: 530px;
    background-color: #F9F9F9;
    margin-bottom: 10px;
  }
  .plan2{
    height: 330px;
    background-color: #F9F9F9;
    margin-bottom: 20px;
  }
  .plan .header{
    position: absolute;
    width: 100%;
    height: 33px;
    background-color: #EEEEEE;
  }
  .plan .header .title{
    position: absolute;
    left: 15px;
    line-height: 33px;
    font-size: 14px;
    font-weight: bold;
    color: #0E050A;
  }
  .plan .header .tip{
    position: absolute;
    right: 10px;
    line-height: 33px;
    font-size: 11px;
    color: #C41335;
  }
  .plan .header img{
    position: absolute;
    top: 10px;
    right: 53px;
    width: 12px;
    height: 12px;
  }

  .plan1 .que-box{
    position: absolute;
    top: 33px;
    width: 100%;
    height: 155px;
    border-bottom: solid 1px #dedede;
    box-sizing: border-box;
  }
  .plan .item-box .title{
    position: relative;
    top: 10px;
    margin-left: 15px;
    margin-right: 15px;
    line-height: 20px;
    color: #000000;
    font-size: 13px;
    font-weight: bold;
  }
  .plan .item-box .title span{
    color: #BEBEBE;
    font-size: 11px;
    font-weight: normal;
  }
  .item-box .tip{
    position: relative;
    margin-top: 12px;
    margin-left: 15px;
    margin-right: 15px;
    color: #808080;
    font-size: 11px;
    line-height: 20px;
  }
  .item-box .tip span{
    color: #c41a34;
  }
  .numberBox{
    position: relative;
    margin-top: 12px;
    margin-left: 15px;
    margin-right: 15px;
    height: 25px;
    line-height: 25px;
  }
  .numberBox .minus{
    position: absolute;
    top: 0px;
    left: 0px;
    font-size: 16px;
    color: #BEBEBE;
    text-align: center;
    width: 25px;
    height: 25px;
    /*line-height: 25px;*/
    border: solid 1px #dedede;
    box-sizing: border-box;
    background-color: #EEEEEE;
  }
  .numberBox .plus{
    position: absolute;
    top: 0px;
    left: 114px;
    font-size: 16px;
    color: #BEBEBE;
    text-align: center;
    width: 25px;
    height: 25px;
    background-color: #FFFFFF;
    border: solid 1px #dedede;
    box-sizing: border-box;
  }
  .numberBox h4{
    margin-top: -2px;
  }
  .numberBox input{
    position: absolute;
    top: 0px;
    left: 31px;
    font-size: 12px;
    color: #333333;
    text-align: center;
    width: 77px;
    height: 25px;
    border: solid 1px #dedede;
    box-sizing: border-box;
    border-radius: 0px;
    background-color: #FFFFFF;
  }
  .cycleBox{
    position: relative;
    margin-top: 12px;
    margin-left: 15px;
    margin-right: 15px;
    height: 25px;
    /*background-color: pink;*/
  }
  .cycleBox .start{
     position: absolute;
     top: 0px;
     left: 0px;
     font-size: 12px;
     color: #333333;
     width: calc(50% - 20px);
     height: 25px;
     line-height: 25px;
     border: solid 1px #dedede;
     box-sizing: border-box;
     background-color: #FFFFFF;
     padding-left: 10px;
     border-radius: 0px;
   }
  .cycleBox .tip11{
    position: absolute;
    top: 0px;
    left: calc(50% - 20px);
    font-size: 12px;
    color: #333333;
    text-align: center;
    width: 40px;
    height: 25px;
    line-height: 25px;
    /*background-color: yellow;*/
  }
  .cycleBox .end{
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 12px;
    color: #333333;
    width: calc(50% - 20px);
    height: 25px;
    line-height: 25px;
    border: solid 1px #dedede;
    box-sizing: border-box;
    background-color: #FFFFFF;
    padding-left: 10px;
    border-radius: 0px;
  }
  .timeBox{
    position: relative;
    margin-top: 20px;
    margin-left: 15px;
    margin-right: 15px;
    height: 25px;
    /*background-color: pink;*/
  }
  .timeBox .sHour{
    position: absolute;
    top: 0px;
    left: 0px;
    font-size: 12px;
    color: #333333;
    width: calc(25% - 20px);
    height: 25px;
    line-height: 25px;
    border: solid 1px #dedede;
    box-sizing: border-box;
    background-color: #FFFFFF;
    padding-left: 10px;
    border-radius: 0px;
  }
  .timeBox .tip11{
    position: absolute;
    top: 0px;
    left: calc(25% - 20px);
    font-size: 12px;
    color: #333333;
    text-align: center;
    width: 20px;
    height: 25px;
    line-height: 25px;
  }
  .timeBox .sSecond{
    position: absolute;
    top: 0px;
    left: calc(25%);
    font-size: 12px;
    color: #808080;
    width: calc(25% - 20px);
    height: 25px;
    line-height: 25px;
    border: solid 1px #dedede;
    box-sizing: border-box;
    background-color: #EEEEEE;
    padding-left: 10px;
    border-radius: 0px;
  }
  .timeBox .tip22{
    position: absolute;
    top: 0px;
    left: calc(50% - 20px);
    font-size: 12px;
    color: #333333;
    text-align: center;
    width: 40px;
    height: 25px;
    line-height: 25px;
  }
  .timeBox .eHour{
    position: absolute;
    top: 0px;
    left: calc(50% + 20px);
    font-size: 12px;
    color: #808080;
    width: calc(25% - 20px);
    height: 25px;
    line-height: 25px;
    border: solid 1px #dedede;
    box-sizing: border-box;
    background-color: #EEEEEE;
    padding-left: 10px;
    border-radius: 0px;
  }
  .timeBox .tip33{
    position: absolute;
    top: 0px;
    left: calc(75%);
    font-size: 12px;
    color: #333333;
    text-align: center;
    width: 20px;
    height: 25px;
    line-height: 25px;
  }
  .timeBox .eSecond{
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 12px;
    color: #808080;
    width: calc(25% - 20px);
    height: 25px;
    line-height: 25px;
    border: solid 1px #dedede;
    box-sizing: border-box;
    background-color: #EEEEEE;
    padding-left: 10px;
    border-radius: 0px;
  }
  .item-box .tip2{
    position: relative;
    margin-top: 10px;
    margin-left: 15px;
    width: 217px;
    color: #c41335;
    font-size: 10px;
    height: 20px;
    line-height: 20px;
    padding: 0px 5px;
    background-color: #FECDCD;
    border-radius: 3px;
  }
  .item-box .tip3{
    position: relative;
    margin-top: 8px;
    margin-left: 15px;
    color: #808080;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
  }
  .item-box .tip3 .tip31{
    color: #333333;
  }
  .item-box .tip3 .tip32{
    color: #c41335;
  }
  /* 单选 多选 */
  .plan1 .que-box .box-input{
    position: relative;
    margin-top: 1px;
    margin-bottom: 5px;
    margin-left: 15px;
    line-height: 20px;
    /*background: pink;*/
  }
  .plan1 .que-box .box-input:nth-child(2){
    margin-top: 20px;
    /*background-color: #FFEECC;*/
  }
  .plan1 .que-box .box-input:last-of-type{
    margin-bottom: 5px;
  }
  .plan1 .que-box .box-input .que-value{
    position: relative;
    color: #333333;
  }
  .plan1 .que-box .box-input .image{
    position: relative;
    top: 0px;
    margin-left: 0px;
    height: 18px;
    width: 18px;
  }
  .plan1 .que-box .box-input .value{
    position: relative;
    top: -12px;
    margin-left: 28px;
    line-height: 5px;
    color: #000000;
    font-size: 13px;
  }
  .plan1 .que-box .box-input .vtip{
    position: relative;
    top: 0px;
    margin-left: 28px;
    line-height: 20px;
    font-size: 10px;
    color: #c41335;
    width: 180px;
    padding: 0 4px;
    border-radius: 3px;
    background-color: #FECDCD;
  }
  .plan1 .cycle-box{
    position: absolute;
    top: 188px;
    width: 100%;
    height: 130px;
    border-bottom: solid 1px #dedede;
    box-sizing: border-box;
  }
  .plan1 .time-box{
    position: absolute;
    top: 318px;
    width: 100%;
    height: 100px;
    border-bottom: solid 1px #dedede;
    box-sizing: border-box;
  }
  .plan1 .person-box{
    position: absolute;
    top: 418px;
    width: 100%;
    height: 112px;
    /*border-bottom: solid 1px #dedede;*/
    /*box-sizing: border-box;*/
  }
  .plan2 .car-box{
    position: absolute;
    top: 33px;
    width: 100%;
    height: 160px;
    border-bottom: solid 1px #dedede;
    box-sizing: border-box;
  }
  .plan2 .cycle-box{
    position: absolute;
    top: 193px;
    width: 100%;
    height: 135px;
    /*border-bottom: solid 1px #dedede;*/
    /*box-sizing: border-box;*/
    /*background-color: yellow;*/
  }

</style>



// WEBPACK FOOTER //
// src/view/emergency-plan-info2.vue